<template>
  <v-container>
    <UserEditComponent
      :is-create="true"
      :is-admin="true"
      @profile-saved="handleSave"
      @snack="throwSnack"></UserEditComponent>
  </v-container>
</template>

<script setup lang="ts">
import UserEditComponent from '@/components/user/UserEditComponent.vue';
import { useSnack } from '@/helpers';
import { useRouter } from 'vue-router';

const router = useRouter();
const emit = defineEmits();
const { throwSnack } = useSnack(emit);
// Form submission handler
const handleSave = async (saved: boolean) => {
  if (saved) {
    router.push({ name: 'AdminUserListing' });
  }
};
</script>
